import Mock from './mock';

import './db/auth';
Mock.onAny().passThrough();
